export default {
    licenses:       { method: 'get',    url: 'licenses' },
    createLicense:  { method: 'post',   url: 'licenses'},
    updateLicense:  { method: 'put',    url: 'licenses/{id}'},
    deleteLicense:  { method: 'delete', url: 'licenses/{id}'}
}